// export const awsBuckets = { //Prod
//     shop_info_bucket: 'coffeepass-shop-info',
//     menu_image_bucket: 'prod-menu-item-images',
// };

export const awsBuckets = { //QA
    shop_info_bucket: 'qa-coffeepass-shop-info',
    menu_image_bucket: 'qa-menu-item-images',
};
